import { ColorPalette } from '../types';

export const colorPalettes: ColorPalette[] = [
  { name: 'Blue Business', colors: ['#3B82F6', '#60A5FA'] },
  { name: 'Green Sales', colors: ['#22C55E', '#4ADE80'] },
  { name: 'Teal Modern', colors: ['#14B8A6', '#2DD4BF'] },
  { name: 'Purple Premium', colors: ['#8B5CF6', '#A78BFA'] },
  { name: 'Slate Professional', colors: ['#64748B', '#94A3B8'] },
  { name: 'Orange Dynamic', colors: ['#F97316', '#FB923C'] },
  { name: 'Red Passion', colors: ['#EF4444', '#F87171'] },
  { name: 'Emerald Fresh', colors: ['#10B981', '#34D399'] },
  { name: 'Indigo Deep', colors: ['#6366F1', '#818CF8'] },
  { name: 'Rose Elegant', colors: ['#F43F5E', '#FB7185'] },
];
